import { Grid } from '@mui/material'
import CommentsInput from 'components/Comments/CommentsInput'
import OrgAccountIds from 'components/Organizations/OrgAccountIds'
import { useOutletContext } from 'react-router-dom'

interface OrganizationContext {
  pinned: boolean
  expanded: boolean
  organization: any
}

const OrganizationIntegration = () => {
  const { expanded } = useOutletContext<OrganizationContext>()

  return (
    <Grid container sx={{ height: '100%' }}>
      <Grid item xs={8} sx={{ height: '100%', pr: 2 }}>
        <CommentsInput
          taskSKs={[]}
          contextFilters={['integration']}
          expanded={expanded}
          context="integration"
          checklistItems={[]}
        />
      </Grid>

      <Grid item xs={4} sx={{ height: '100%' }}>
        <OrgAccountIds />
      </Grid>
    </Grid>
  )
}

export default OrganizationIntegration
